import { capitalCase } from "change-case";
import { Css, Palette } from "~generated/css";
import { LotMapSalesStatus } from "../organisms/LotMap";

type LotSaleStatusLabelProps = {
  status: LotMapSalesStatus;
  size?: "small" | "large";
  // Shows a more detailed label in cards than in map legend
  isCardLotLabel?: boolean;
};

const STATUS_TO_COLOR: Record<LotMapSalesStatus, Palette> = {
  RESERVED: Palette.SaturatedWine,
  AVAILABLE: Palette.SaturatedGrass,
  MODEL_HOME: Palette.SaturatedOrange,
  CONSTRUCTION_STARTED: Palette.BrightBlue,
  MOVE_IN_READY: Palette.Plum,
  EXISTING_RESIDENTIAL: Palette.White,
};

export function LotSaleStatusLabel(props: LotSaleStatusLabelProps) {
  const { status, size = "large", isCardLotLabel = false } = props;

  return (
    <div css={Css.df.aic.gap1.$}>
      <div
        css={
          Css.wPx(24)
            .hPx(16)
            .borderRadius("20px")
            .bgColor(STATUS_TO_COLOR[status])
            .if(size === "small")
            .wPx(16)
            .hPx(12)
            // Snowflake pill style for existing residential
            .if(status === "EXISTING_RESIDENTIAL").bss.bw2.bcGray.$
        }
      />
      <div css={Css.wsnw.t14.gray80.if(size === "small").t12.gray80.$}>
        {getLotSalesStatusLabel(status, isCardLotLabel)}
      </div>
    </div>
  );
}

// Cards and move in ready have finnicky rules
function getLotSalesStatusLabel(status: LotMapSalesStatus, isCardLotLabel: boolean): string {
  if (isCardLotLabel) {
    return status === LotMapSalesStatus.Available
      ? "Available Lot"
      : status === LotMapSalesStatus.ConstructionStarted
        ? "Available, Construction Started"
        : status === LotMapSalesStatus.MoveInReady
          ? "Available, Move-in Ready"
          : capitalCase(status);
  }

  if (status === LotMapSalesStatus.MoveInReady) return "Move-in Ready";

  return capitalCase(status);
}
